import classNames from "classnames";
import { useState } from "react";
import { Button, Collapse, Nav } from "react-bootstrap";
import { Fragment } from "react/jsx-runtime";

import { BootstrapNavLink } from "@/components/BootstrapNavLink";
import { Icon } from "@/components/Icon";
import { Job } from "./queries/job-by-name";

export const JobTrackerNav: React.FC<{ job: Job }> = ({ job }) => {
  const [detailsOpen, setDetailsOpen] = useState(false);
  const toggleDetails = () => {
    setDetailsOpen((open) => !open);
  };

  const evolvedOpportunityNumbers = [
    job.customFieldValues.find((x) => x.customFieldDefinitionId === 28)?.value,
    job.customFieldValues.find((x) => x.customFieldDefinitionId === 31)?.value,
  ]
    .filter((x): x is string => !!x)
    .map((x) => `GNM#${x}`)
    .join(", ");

  const orderDetails: [string, string | undefined | null][] = [
    ["Evolved #", evolvedOpportunityNumbers],
    ["Customer", job.customer?.name],
    ["Model", job.customFieldValues.find((x) => x.customFieldDefinitionId === 18)?.value],
    ["Date", job.customFieldValues.find((x) => x.customFieldDefinitionId === 22)?.value],
  ];

  return (
    <Nav
      activeKey={window.location.href}
      className="flex-column nav-pills"
      style={{ "--bs-nav-pills-border-radius": 0 }}
    >
      <Nav.Item className="text-wrap px-3">
        <Button variant="link" size="sm" onClick={toggleDetails} className="px-0 text-reset text-decoration-none">
          <h1 className="h3 d-inline m-0">{job.number}</h1>
          <Icon icon={detailsOpen ? "caret-down-square" : "caret-right-square"} className="ms-2 mb-1" />
        </Button>
        <Collapse in={detailsOpen}>
          <dl className="m-0">
            {orderDetails
              .filter(([, value]) => value)
              .map(([label, value], index, array) => (
                <Fragment key={label}>
                  <dt>{label}</dt>
                  <dd className={classNames({ "m-0": index === array.length - 1 })}>{value}</dd>
                </Fragment>
              ))}
          </dl>
        </Collapse>
      </Nav.Item>
      <hr />
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/details`}>
          <Icon icon="file-text" className="me-2" />
          Order Details
        </BootstrapNavLink>
      </Nav.Item>
      {/*
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/financial-summary`}>
          <Icon icon="cash-coin" className="me-2" />
          Financial Summary
        </BootstrapNavLink>
      </Nav.Item>
      */}
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/erns`}>
          <Icon icon="gear-wide-connected" className="me-2" />
          ERNs
        </BootstrapNavLink>
      </Nav.Item>
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/bom-hierarchy`}>
          <Icon icon="list-nested" className="me-2" />
          BOM Hierarchy
        </BootstrapNavLink>
      </Nav.Item>
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/bom-by-component`}>
          <Icon icon="list" className="me-2" />
          BOM By Component
        </BootstrapNavLink>
      </Nav.Item>
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/existing-inventory`}>
          <Icon icon="boxes" className="me-2" />
          Existing Inventory
        </BootstrapNavLink>
      </Nav.Item>
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/purchase-orders`}>
          <Icon icon="cart" className="me-2" />
          Purchase Orders
        </BootstrapNavLink>
      </Nav.Item>
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/purchasing-progress`}>
          <Icon icon="file-text" className="me-2" />
          Purchasing Progress
        </BootstrapNavLink>
      </Nav.Item>
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/landed-costs`}>
          <Icon icon="receipt" className="me-2" />
          Landed Costs
        </BootstrapNavLink>
      </Nav.Item>
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/work-orders`}>
          <Icon icon="wrench-adjustable" className="me-2" />
          Work Orders
        </BootstrapNavLink>
      </Nav.Item>
      {/*
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/work-order-creation`}>
          <Icon icon="wrench-adjustable-circle" className="me-2" />
          Work Order Creation
        </BootstrapNavLink>
      </Nav.Item>
      */}
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/builds`}>
          <Icon icon="hammer" className="me-2" />
          Builds
        </BootstrapNavLink>
      </Nav.Item>
      {/*
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/fabrication-progress`}>
          <Icon icon="tools" className="me-2" />
          Fabrication Progress
        </BootstrapNavLink>
      </Nav.Item>
      */}
      <Nav.Item>
        <BootstrapNavLink to={`/job/${job.number}/shipments`}>
          <Icon icon="truck" className="me-2" />
          Shipments
        </BootstrapNavLink>
      </Nav.Item>
    </Nav>
  );
};
